export enum TransferType {
	USER,
	POSITION
}
